module.exports = __webpack_public_path__ + "img/share-gray-icon.f2d14591.png";